import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Youtube, Mail, Phone, MapPin } from 'lucide-react';
import { footerLinks } from '../../data/mockData';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      {/* Newsletter Section */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="max-w-xl mx-auto text-center">
            <h3 className="text-2xl font-light tracking-wider mb-4">BÜLTENIMIZE ABONE OLUN</h3>
            <p className="text-gray-400 text-sm mb-6">
              Yeni koleksiyonlar ve özel fırsatlardan haberdar olun
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-1 bg-white/10 border border-white/20 px-4 py-3 text-sm focus:outline-none focus:border-white transition-colors"
              />
              <button className="bg-white text-black px-8 py-3 text-sm tracking-wider hover:bg-gray-100 transition-colors">
                ABONE OL
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_code-collaborator-8/artifacts/u825wqya_Valmera%20Logo%20%281%29.png"
              alt="VALMÉRA"
              className="h-16 mb-6"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Valméra, on yıllık üç arkadaşın dostluktan anlam ürettiği bir yolculuk.
              Görüneni değil, hissedileni tasarlıyoruz.
            </p>
            <p className="text-gray-500 text-xs italic mb-6">
              "Güzelliği yüzeyde değil, özde arayanlar için."
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/valmeraofficial/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://www.youtube.com/@ValmeraOfficial" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 className="text-sm font-medium tracking-wider mb-6">ALIŞVERİŞ</h4>
            <ul className="space-y-3">
              {footerLinks.shop.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 text-sm hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-medium tracking-wider mb-6">KURUMSAL</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 text-sm hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-sm font-medium tracking-wider mb-6">DESTEK</h4>
            <ul className="space-y-3">
              {footerLinks.support.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 text-sm hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-wrap items-center justify-center gap-8 text-sm text-gray-400">
            <a 
              href="https://wa.me/905465937071" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-white transition-colors"
            >
              <Phone size={16} />
              <span>0546 593 70 71</span>
            </a>
            <a 
              href="mailto:officialvalmera@gmail.com"
              className="flex items-center gap-2 hover:text-white transition-colors"
            >
              <Mail size={16} />
              <span>officialvalmera@gmail.com</span>
            </a>
            <div className="flex items-center gap-2">
              <MapPin size={16} />
              <span>Uşak Merkez</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-gray-500">
            <p>© 2025 VALMÉRA. Tüm hakları saklıdır.</p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-white transition-colors">Gizlilik Politikası</a>
              <a href="#" className="hover:text-white transition-colors">Kullanım Koşulları</a>
              <a href="#" className="hover:text-white transition-colors">Çerez Politikası</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
